import React from 'react';
import './requiredField.scss';

export default function RequiredField(props) {
  return (
    <div className={`orange-box ${props.class}`}> { /* eslint-disable-line */ }
      <p className="text">
      REQUIRED
      </p>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/modules/common/requiredField.js